import React from 'react';
import { useSelector } from 'react-redux';
import LazyLoader from 'react-lazyload';
import loadable from '@loadable/component';
import { Tag } from '@lux/title';
import { useTranslate } from '@pegasus/translation';

import { getClientDeviceHeight } from '@client/redux/modules/clientDevice';
import { SectionTitle } from '@client/components/shared/Shared';
import { RecommendationLegacy } from '@shared/types/recommendation';

const Recommendations = loadable(
    () =>
        import(
            /* webpackChunkName: "Recommendations" */ '@client/components/shared/recommendations/Recommendations'
        ),
);

interface Props {
    recommendations: RecommendationLegacy[];
    width: number;
    itemWidth: number;
    source: number;
}

const RecommendationsWrapper: React.FC<Props> = props => {
    const deviceHeight = useSelector(getClientDeviceHeight);
    const translate = useTranslate();

    return (
        <LazyLoader offset={deviceHeight * 2} once>
            <>
                <SectionTitle message="recommendations.sectionTitle" tag={Tag.H2} />
                <Recommendations
                    {...props}
                    carouselAriaLabel={translate('recommendations.sectionTitle')}
                    nextButtonAriaLabel={translate('recommendations.next')}
                    previousButtonAriaLabel={translate('recommendations.previous')}
                />
            </>
        </LazyLoader>
    );
};

export default RecommendationsWrapper;
